import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Industries from './components/Industries';
import Grayson from './components/Grayson';
import FinalCTA from './components/FinalCTA';
import ConsultationForm from './components/ConsultationForm';

export default function Home() {
  return (
    <div className="bg-[#1A1C1E] min-h-screen">
      <Header />
      <div id="hero">
        <Hero />
      </div>
      <div id="how-it-works">
        <HowItWorks />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="industries">
        <Industries />
      </div>
      <div id="grayson">
        <Grayson />
      </div>
      <FinalCTA />
      <ConsultationForm />
      <Footer />
    </div>
  );
}
